import { createSelector } from 'reselect'

const getLibraries = state => state.libraries

const private_library_preview_request_selector = createSelector(
	[ getLibraries ],
	library => ({
		libraryUID: library.current.libraryUID,
	})
)

export default private_library_preview_request_selector
